export interface LandingStepGroup {
  title: string;
  steps: string[];
}

export const landingSteps: LandingStepGroup[] = [
  {
    title: 'For taskers',
    steps: [
      'Sign up with your city. Takes a minute.',
      'Get pinged when a paid gig opens near you.',
      'Do it, snap the proof, get paid within 24h.',
    ],
  },
  {
    title: 'For companies',
    steps: [
      'Tell us where you need people and what for.',
      'We match you with verified locals in that city.',
      'Get photos, receipts, or logs back. Pay only for approved work.',
    ],
  },
];
